export const industries = [
  { value: "authorities", label: "Authorities" },
  { value: "education-university-research", label: "Education / University / Research" },
  { value: "supplier", label: "Supplier" },
  { value: "engineering-office", label: "Engineering office" },
  { value: "light-sensor-manufacturer", label: "Light - Sensor Manufacturer" },
  { value: "electric-and-lighting-trade", label: "Electric and lighting trade" },
  { value: "contracting", label: "Contracting" },
  { value: "architect-office", label: "Architect office" },
  { value: "power-company", label: "Power company" },
  { value: "contractors", label: "Contractors" },
  { value: "other", label: "Other" },
];
